/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
    RoleToJSONTyped,
} from './Role';
import type { Action } from './Action';
import {
    ActionFromJSON,
    ActionFromJSONTyped,
    ActionToJSON,
    ActionToJSONTyped,
} from './Action';
import type { Party } from './Party';
import {
    PartyFromJSON,
    PartyFromJSONTyped,
    PartyToJSON,
    PartyToJSONTyped,
} from './Party';
import type { Revision } from './Revision';
import {
    RevisionFromJSON,
    RevisionFromJSONTyped,
    RevisionToJSON,
    RevisionToJSONTyped,
} from './Revision';
import type { DocumentId } from './DocumentId';
import {
    DocumentIdFromJSON,
    DocumentIdFromJSONTyped,
    DocumentIdToJSON,
    DocumentIdToJSONTyped,
} from './DocumentId';
import type { ResponsibleParty } from './ResponsibleParty';
import {
    ResponsiblePartyFromJSON,
    ResponsiblePartyFromJSONTyped,
    ResponsiblePartyToJSON,
    ResponsiblePartyToJSONTyped,
} from './ResponsibleParty';
import type { Property } from './Property';
import {
    PropertyFromJSON,
    PropertyFromJSONTyped,
    PropertyToJSON,
    PropertyToJSONTyped,
} from './Property';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface Metadata
 */
export interface Metadata {
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof Metadata
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    title?: string;
    /**
     * 
     * @type {Date}
     * @memberof Metadata
     */
    published?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Metadata
     */
    lastModified?: Date;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    oscalVersion?: string;
    /**
     * 
     * @type {Array<Party>}
     * @memberof Metadata
     */
    parties?: Array<Party>;
    /**
     * 
     * @type {Array<Role>}
     * @memberof Metadata
     */
    roles?: Array<Role>;
    /**
     * 
     * @type {Array<ResponsibleParty>}
     * @memberof Metadata
     */
    responsibleParties?: Array<ResponsibleParty>;
    /**
     * 
     * @type {Array<Property>}
     * @memberof Metadata
     */
    props?: Array<Property>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof Metadata
     */
    links?: Array<Link>;
    /**
     * 
     * @type {Array<Revision>}
     * @memberof Metadata
     */
    revisions?: Array<Revision>;
    /**
     * 
     * @type {Array<DocumentId>}
     * @memberof Metadata
     */
    documentIds?: Array<DocumentId>;
    /**
     * 
     * @type {Array<Location>}
     * @memberof Metadata
     */
    locations?: Array<Location>;
    /**
     * 
     * @type {Array<Action>}
     * @memberof Metadata
     */
    actions?: Array<Action>;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    remarks?: string;
}

/**
 * Check if a given object implements the Metadata interface.
 */
export function instanceOfMetadata(value: object): value is Metadata {
    return true;
}

export function MetadataFromJSON(json: any): Metadata {
    return MetadataFromJSONTyped(json, false);
}

export function MetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): Metadata {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'published': json['published'] == null ? undefined : (new Date(json['published'])),
        'lastModified': json['lastModified'] == null ? undefined : (new Date(json['lastModified'])),
        'version': json['version'] == null ? undefined : json['version'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'parties': json['parties'] == null ? undefined : ((json['parties'] as Array<any>).map(PartyFromJSON)),
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(RoleFromJSON)),
        'responsibleParties': json['responsibleParties'] == null ? undefined : ((json['responsibleParties'] as Array<any>).map(ResponsiblePartyFromJSON)),
        'props': json['props'] == null ? undefined : ((json['props'] as Array<any>).map(PropertyFromJSON)),
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(LinkFromJSON)),
        'revisions': json['revisions'] == null ? undefined : ((json['revisions'] as Array<any>).map(RevisionFromJSON)),
        'documentIds': json['documentIds'] == null ? undefined : ((json['documentIds'] as Array<any>).map(DocumentIdFromJSON)),
        'locations': json['locations'] == null ? undefined : ((json['locations'] as Array<any>).map(LocationFromJSON)),
        'actions': json['actions'] == null ? undefined : ((json['actions'] as Array<any>).map(ActionFromJSON)),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MetadataToJSON(json: any): Metadata {
    return MetadataToJSONTyped(json, false);
}

export function MetadataToJSONTyped(value?: Metadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'title': value['title'],
        'published': value['published'] == null ? undefined : ((value['published']).toISOString()),
        'lastModified': value['lastModified'] == null ? undefined : ((value['lastModified']).toISOString()),
        'version': value['version'],
        'oscalVersion': value['oscalVersion'],
        'parties': value['parties'] == null ? undefined : ((value['parties'] as Array<any>).map(PartyToJSON)),
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleToJSON)),
        'responsibleParties': value['responsibleParties'] == null ? undefined : ((value['responsibleParties'] as Array<any>).map(ResponsiblePartyToJSON)),
        'props': value['props'] == null ? undefined : ((value['props'] as Array<any>).map(PropertyToJSON)),
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(LinkToJSON)),
        'revisions': value['revisions'] == null ? undefined : ((value['revisions'] as Array<any>).map(RevisionToJSON)),
        'documentIds': value['documentIds'] == null ? undefined : ((value['documentIds'] as Array<any>).map(DocumentIdToJSON)),
        'locations': value['locations'] == null ? undefined : ((value['locations'] as Array<any>).map(LocationToJSON)),
        'actions': value['actions'] == null ? undefined : ((value['actions'] as Array<any>).map(ActionToJSON)),
        'remarks': value['remarks'],
    };
}

